import { TxtContainer } from 'components/Main/Main.styles';
import { useContext, useState, useEffect } from 'react';
import styled, { useTheme } from 'styled-components';
import KPIContainer from './KPIContainer';
import KPICharts from './KPICharts';
import ReportsLinks from './ReportsLinks';
import { useCampaignContext } from 'context/CampaignContext';
import { DarkButton } from 'components/style/Global';
import Comments from 'components/Comments/Comments';
import ReactLoading from 'react-loading';
import { PublishContext } from 'context/PublishContext';
import { colorsForIcon } from '../Brief/UploadFile/2.2.UploadFile';
import { QueryInfo } from '../Brief/Brief';
import FileList from '../Brief/UploadFile/3.3.FilesList';
import { UploadFileContainer } from '../Brief/style/BriefInputStyle';
import { useSearchParams } from 'react-router-dom';
import { API, Auth } from 'aws-amplify';
import { getStoredQuery } from 'graphql/queries';
import { DeleteStoredQueryMutation, GetStoredQueryQuery, UserQuery } from 'API';
import { getFilesFromS3 } from '../Brief/UploadFile/getFilesfromS3';
import APIContext from 'context/APIContext';
import { deleteStoredQuery } from 'graphql/mutations';
import { useClientContext } from 'context/ClientContext';
import ClientStatementsContext from 'context/ClientStatementsContext';
import { usePortalContext } from 'context/PortalContext';
import { useLoggingActivity } from 'customHooks/useLogging';
// import { useEnrichedContext } from 'context/EnrichedContext';

type Props = {
  approvedBudget: number | null;
};

export const SummaryContainer = styled.div`
  margin-top: 30px;

  .buble .bubletext {
    visibility: hidden;
    width: fit-content;
    background-color: transparent;
    color: ${({ theme }) => theme.primaryGray};
    text-align: center;
    background-color: ${({ theme }) => theme.placeholderBackground};
    border: 1px solid ${({ theme }) => theme.primaryGray};
    border-radius: 7px;
    padding: 3px 8px;
    font-weight: normal;

    /* Position the tooltip */
    position: absolute;
    right: 5vw;
    top: 15vw;
    z-index: 1;
  }

  .buble:hover .bubletext {
    visibility: visible;
  }
`;
export const SubContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 7px;
  width: 100%;
  padding: 30px 40px;
  margin-bottom: 0.5vw;

  h1 {
    font-size: 1vw;
    font-family: 'fontBold';
    font-weight: normal;
  }
  .texAreaContainer {
    padding: 1vw 0 0vw 0.3vw;
  }
  textarea {
    font-size: 12px;
    font-family: 'fontRegular';
    padding: 8px;
    border-radius: 7px;
    border: 1px solid ${({ theme }) => theme.border};
    color: ${({ theme }) => theme.primaryGray};
    background-color: ${({ theme }) => theme.background};
    resize: none;
    min-height: 100px;
    width: 100%;
  }
  .error {
    padding: 0.5vw 1vw;
    white-space: nowrap;
    h4 {
      font-size: 14px;
      font-weight: normal;
      font-family: 'FontBold';
      color: ${({ theme }) => theme.primaryGray};
      margin-bottom: 1vw;
    }
    h5 {
      font-size: 14px;
      font-weight: normal;
      font-family: 'FontRegular';
      color: ${({ theme }) => theme.primaryGray};
    }
  }
  .loader {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const PublishedButton = styled.div`
  position: absolute;
  right: 100px;
  border: 1px solid lightgray;
  padding: 7px;
  border-radius: 7px;
  padding-left: 12px;
  padding-right: 12px;
  color: #807f83;
  cursor: pointer;

  &:hover {
    border-color: black;
  }
`;

const Summary = (props: Props) => {
  const { approvedBudget } = props;
  const { activeCampaign, actualBudget } = useCampaignContext();
  const { handlePublishSummary, campaignOverFlowqueryStatus, unpublishCampaign } = useContext(PublishContext);
  const logActivity = useLoggingActivity();
  // const { fullSources } = useEnrichedContext();

  const [toggleComment, setToggleComment] = useState(true);
  // const [selectedDocument, setSelectedDocument] = useState([] as QueryInfo[]);

  const colorArray = colorsForIcon;
  const { getEnvironment } = useContext(APIContext);
  const [uploadedFiles, setUploadedFiles] = useState<QueryInfo[]>([]);
  const { userAccess } = useClientContext();
  const { statements } = useContext(ClientStatementsContext);
  const { setCopyOfTab } = usePortalContext();
  const isClient = userAccess ? userAccess.readAccess : true;
  const { fullAccess = false, readAccess = false, noAccess = false } = userAccess || {};

  // Set tab in useEffect to avoid setState during render
  useEffect(() => {
    setCopyOfTab('summary');
  }, [setCopyOfTab]); // Include setCopyOfTab in dependencies

  async function fetchStoredQueriesID(position: string): Promise<File> {
    try {
      const response = (await API.graphql({
        query: getStoredQuery,
        variables: {
          campaign_id: activeCampaign?.campaignId?.toString(),
          position: position,
        },
        authMode: 'AMAZON_COGNITO_USER_POOLS',
      })) as { data: GetStoredQueryQuery };
      const responseID = response.data.getStoredQuery;

      const file = await getFilesFromS3(
        responseID as UserQuery,
        activeCampaign?.ClientCode as string,
        activeCampaign?.ClientCountry as string,
        getEnvironment,
      );

      if (file) {
        setUploadedFiles((prev) =>
          prev.map((e) => {
            if (e.id === responseID?.query_id) {
              return { ...e, file: file };
            } else {
              return e;
            }
          }),
        );
      }

      return file as File;
    } catch (e) {
      console.log(`ERROR WAS THIS: ${e}`);
      return {} as File;
    }
  }

  const openFile = async (file2: QueryInfo) => {
    const file = file2.file ?? (await fetchStoredQueriesID(file2.position));
    // const file = file2.file as File;
    const url = URL.createObjectURL(file);
    const link = document.createElement('a');
    link.href = url;
    // link.target = '_blank';
    // link.target = '_blank';
    link.download = file2.name;
    link.click();
  };

  async function removeFromS3(position: string) {
    try {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const deleteStoredQ = (await API.graphql({
        query: deleteStoredQuery,
        variables: {
          campaign_id: activeCampaign?.campaignId?.toString(),
          Environment: getEnvironment,
          placeholder: position,
        },
        authMode: 'AMAZON_COGNITO_USER_POOLS',
      })) as { data: DeleteStoredQueryMutation };
    } catch (e) {
      console.log('ERROR  DELETING QUERY', e);
    }
  }

  const removeFile = (queryInfo: QueryInfo) => {
    setUploadedFiles(uploadedFiles.filter((f) => f.id !== queryInfo.id));
    removeFromS3(queryInfo.position);
  };

  const isUserAuthorized = activeCampaign?.authorized;
  const Create = statements?.Queries?.CREATE;

  const theme = useTheme();
  const availableDashboards = activeCampaign?.dashboardType
    .filter((a) => a !== 'INSOURCE_DATA')
    .filter((a) => a !== 'OVERWRITE')
    // .filter((a) => {
    //   if (a === 'TV' && !fullSources?.some((s) => s.source_name === 'DATASOURCE#ADE')) {
    //     return false;
    //   } else {
    //     return a;
    //   }
    // })
    .map((e) => {
      const dash = e as string;
      const subs = activeCampaign?.subcampaign;
      const arr = [];

      // Definiraj koje tipove treba provjeriti
      let typesToCheck: string[] = [];
      if (dash === 'TV' || dash === 'BVOD') {
        typesToCheck = ['TV', 'BVOD'];
      } else {
        typesToCheck = [dash];
      }

      for (const [, value] of Object.entries(subs)) {
        const publishedobj = (value as any).published;
        // Provjeri sve tipove za ovaj dash
        const isAnyTypePublished = typesToCheck.some((typeToCheck) => publishedobj[typeToCheck] === true);
        arr.push(isAnyTypePublished);

        if (activeCampaign?.childCampaigns && activeCampaign?.childCampaigns.length > 0) {
          activeCampaign?.childCampaigns.forEach((child) => {
            const childSubs = (child as any).subcampaign;
            for (const [, childValue] of Object.entries(childSubs)) {
              const childPublishedobj = (childValue as any).published;
              const isChildAnyTypePublished = typesToCheck.some(
                (typeToCheck) => childPublishedobj[typeToCheck] === true,
              );
              arr.push(isChildAnyTypePublished);
            }
          });
        }
        if (activeCampaign.campaignPeriods && activeCampaign.campaignPeriods.length > 0) {
          activeCampaign.campaignPeriods.forEach((period) => {
            const periodSubs = (period as any).subcampaign;
            for (const [, periodValue] of Object.entries(periodSubs)) {
              const periodPublishedobj = (periodValue as any).published;
              const isPeriodAnyTypePublished = typesToCheck.some(
                (typeToCheck) => periodPublishedobj[typeToCheck] === true,
              );
              arr.push(isPeriodAnyTypePublished);
            }
          });
        }
      }
      return {
        [dash]: arr.some((e) => e === true),
      };
    });

  const isAllPublished = availableDashboards && availableDashboards.every((e) => Object.values(e)[0] === true);

  const unpublishedDashboards = availableDashboards
    ? availableDashboards.filter((e) => Object.values(e)[0] !== true).map((e) => Object.keys(e)[0])
    : [];

  const [bubleVisible, setBubleVisible] = useState(false);

  const handlePublishClick = async () => {
    // Log the summary publish activity
    logActivity({
      action: 'SUMMARY_PUBLISH',
    }).catch(console.error);

    // Call the original publish function
    handlePublishSummary();
  };

  const handleBuble = () => {
    setBubleVisible(!bubleVisible);
    setTimeout(() => {
      setBubleVisible(false);
    }, 3000);
  };

  return (
    <SummaryContainer>
      {activeCampaign?.authorized ||
      (!activeCampaign?.authorized && activeCampaign?.status === 'CAMPAIGN_PUBLISHED') ? (
        <SubContainer>
          <>
            {campaignOverFlowqueryStatus !== 'RUNNING' ? (
              <>
                <div style={{ display: 'flex' }}>
                  <h1>KEY FIGURES</h1>

                  {activeCampaign && activeCampaign?.authorized && (
                    <>
                      {activeCampaign?.status === 'CAMPAIGN_PUBLISHED' ? (
                        <PublishedButton onClick={() => unpublishCampaign()}>Published</PublishedButton>
                      ) : (
                        <>
                          {isAllPublished ? (
                            <DarkButton
                              onClick={() => handlePublishClick()}
                              style={{ position: 'absolute', right: '100px' }}
                            >
                              Publish
                            </DarkButton>
                          ) : (
                            <>
                              <button
                                onClick={handleBuble} /* onClick={() => handlePublishSummary()} */
                                style={{ position: 'absolute', right: '100px' }}
                              >
                                Publish
                              </button>
                              <span className="buble">
                                <span className="bubletext" style={{ visibility: bubleVisible ? 'visible' : 'hidden' }}>
                                  Please ensure all reports are published before publishing the Summary page.{' '}
                                  {unpublishedDashboards.length > 0 && (
                                    <>Not yet published: {unpublishedDashboards.join(', ')}.</>
                                  )}
                                </span>
                              </span>
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
                {actualBudget === -1 ? (
                  <div className="error">
                    <h4>Something went wrong.</h4>
                    <br />
                    <h5>
                      An error occured while processing your request. <br />
                      Please try again or contact support.
                    </h5>
                  </div>
                ) : actualBudget === -2 ? (
                  <>
                    <TxtContainer className="loader">
                      <ReactLoading type="spinningBubbles" color={theme.publishButton} />
                    </TxtContainer>
                  </>
                ) : (
                  <div className="KPIContainer">
                    {activeCampaign && <KPIContainer approvedBudget={approvedBudget}></KPIContainer>}
                    <KPICharts></KPICharts>
                  </div>
                )}
                <h1>KEY INTAKES AND NOTES</h1>
                <Comments
                  header={false}
                  toggleComment={toggleComment}
                  componentID="overall"
                  setToggleComment={(toggleComment: boolean) => setToggleComment(toggleComment)}
                ></Comments>
              </>
            ) : (
              <div className="loader">
                <ReactLoading type="spinningBubbles" color={theme.publishButton} />
              </div>
            )}
          </>
        </SubContainer>
      ) : (
        <SubContainer>
          <h1>CAMPAIGN SUMMARY</h1>
          <div className="error">
            <h4>There is no campaign summary available</h4>
            <br />
            <h5>
              The campaign is ongoing, or the reports are not yet ready.
              <br />
              Please reach out to your agency contact person.
            </h5>
          </div>
        </SubContainer>
      )}

      <SubContainer>
        <h1>INDIVIDUAL REPORTS</h1>
        {activeCampaign && (
          <ReportsLinks
            uploadedFiles={uploadedFiles}
            setUploadedFiles={setUploadedFiles}
            isClient={isClient}
            fullAccess={fullAccess}
            isUserAuthorized={isUserAuthorized}
          ></ReportsLinks>
        )}
        <div>
          <>
            {
              // (isUserAuthorized && Create) || (!isUserAuthorized && activeCampaign?.status === 'CAMPAIGN_PUBLISHED') ? (
              <UploadFileContainer>
                <div className="uploadedFilesRightContianer" style={{ marginLeft: '0px', paddingTop: '20px' }}>
                  {uploadedFiles.length > 0 && (
                    <>
                      <h4>Campaign evaluation files</h4>
                      <FileList
                        isAuthorized={activeCampaign?.authorized}
                        files={uploadedFiles}
                        onFileOpen={openFile}
                        onFileRemove={removeFile}
                        colorsForIcon={colorArray}
                      />
                    </>
                  )}
                </div>
              </UploadFileContainer>
              // ) : (
              //   <></>
              // )
            }
          </>
        </div>
      </SubContainer>
    </SummaryContainer>
  );
};

export default Summary;
